<template>
  <div class="louceng">
    <div
      class="ablum_are left"
      v-for="(item, item1) in list"
      :key="item1.index"
    >
      <!-- 时间区域 -->
      <div class="time_upload" :id="item1">
        <span>{{ item1 }}</span>
      </div>
      <!-- 图片展示区域 -->
      <div class="imgdiv" v-for="item in item" :key="item.id">
        <el-popover placement="right" title trigger="click">
          <img :src="item.album_url" />
          <img
            slot="reference"
            :src="item.album_url"
            style="
              width: 148px;
              height: 148px;
              padding: 0 7px 7px 0;
              border-radius: 6px;
            "
          />
        </el-popover>
        <div class="imgtip">
          <div class="delete_img" @click="srclist(item.album_id)">
            <i class="el-icon-delete"></i>
          </div>
          <div class="collection_img" @click="off(item)">
            <i
              class="el-icon-star-off"
              :class="{ ashow: item.colstatus == 2 }"
            ></i>
            <svg
              class="icon"
              aria-hidden="true"
              :class="{ ashow: item.colstatus == 1 }"
            >
              <use xlink:href="#iconcollection-b-copy" />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <delete v-show="bshow"></delete>
  </div>
</template>

<script>
import Delete from "../../components/space/delete";
import VueEvent from "../../api/eventBus";
import URL from "../../api/index";
import axios from "axios";
export default {
  props: ["list"],
  components: {
    Delete,
  },
  data() {
    return {
      UserInfo: "",
      isshow: false,
      bshow: false,
    };
  },
  mounted() {},

  methods: {
    srclist(e) {
      var that = this;
      that.bshow = true;
      VueEvent.$emit("num", "1");
      VueEvent.$off("tab");
      VueEvent.$on("tab", function (data) {
        that.del(e);
      });
    },
    del(e) {
      var that = this;
      // 相册删除数据上报
      that.getRjwDel(JSON.parse(localStorage.getItem("loginInfo")), e);
      that.UserInfo = JSON.parse(window.localStorage.getItem("info"));
      var delalbum_data = {
        token: that.UserInfo.token,
        photoid: e,
      };
      // 照片删除
      this.$post(URL.delalbum, delalbum_data).then((res) => {
        if (res.state == "0") {
          VueEvent.$emit("ling", "0");
        } else if (res.state == "1") {
          VueEvent.$emit("ling", "1");
        }
        that.$emit("shuaxin", "zhaopian");
      });
    },
    off(e) {
      var that = this;
      that.UserInfo = JSON.parse(window.localStorage.getItem("info"));
      var data = {
        token: that.UserInfo.token,
        coltype: "album",
        content: e.album_id,
      };
      //收藏取消收藏
      this.$post(URL.collect, data).then((res) => {
        if (res.msg == "收藏") {
          e.colstatus = 1;
          that.getRjwCollect(JSON.parse(localStorage.getItem("loginInfo")), e.album_id);
        } else {
          e.colstatus = 2;
          that.getRjwUnCollect(JSON.parse(localStorage.getItem("loginInfo")), e.album_id)
        }
      });
    },
    //数据上报-删除
    getRjwDel(hh, row) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_delete",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的删除功能",
          data: {
            function: "相册",
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
            delete_id: row,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    //上报数据-收藏
    getRjwCollect(hh, row) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_collect",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的收藏功能",
          data: {
            function: "相册",
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
            bycollect_id: row,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    //上报数据-取消收藏
    getRjwUnCollect(hh, row) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_collectcancel",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的取消收藏功能",
          data: {
            function: "相册",
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
            bycancelcollect_id: row,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.ablum_are {
  width: 100%;
  background-color: #fff;
  overflow: hidden;
  margin-bottom: 20px;
  .time_upload {
    margin-bottom: 15px;
    span {
      margin: 0;
      font-size: 18px;
      color: #000;
    }
  }
  .imgdiv {
    position: relative;
    float: left;
    margin: 0 5px 5px 0;
    &:hover {
      cursor: pointer;
      .imgtip {
        opacity: 0.5;
      }
    }
    .imgtip {
      position: absolute;
      bottom: 15px;
      right: 15px;
      opacity: 0;
      div {
        background-color: #000;

        float: left;
        width: 38px;
        height: 25px;
        line-height: 25px;
        cursor: pointer;
        border-radius: 2px;
        color: #fff;
        text-align: center;
        margin-left: 3px;
      }
    }
  }
}
.el-image-viewer__img {
  margin-left: none !important;
}
.el-icon-star-off {
  display: none;
}
.icon {
  display: none;
}
.ashow {
  display: block;
  margin-top: 5px;
}
.icon {
  width: 16px;
  height: 16px;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
